import { render } from "./ImageModal2.vue?vue&type=template&id=d0598e86"
import script from "./ImageModal2.vue?vue&type=script&lang=js"
export * from "./ImageModal2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__